import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { PasswordInput } from "../components/PasswordInput";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const doLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await login(email, password); toast.success("Welcome back"); nav("/dashboard"); }
    catch (err) { toast.error(err.response?.data?.detail || "Login failed"); }
    finally { setLoading(false); }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="login-page" className="max-w-md mx-auto px-6 py-20">
      <div className="uppercase text-xs tracking-[0.3em] font-bold text-center" style={{color: "var(--secondary)"}}>Sign in</div>
      <h1 className="font-serif text-5xl mt-3 text-center leading-none" style={{color: "var(--primary)"}}>Welcome back.</h1>
      <form onSubmit={doLogin} className="mt-10 bg-white rounded-lg border hairline p-8 space-y-5">
        <div><Label>Email</Label><Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}/></div>
        <div><Label>Password</Label><PasswordInput data-testid="login-password" required value={password} onChange={(e) => setPassword(e.target.value)}/></div>
        <Button data-testid="login-submit" disabled={loading} type="submit" className="w-full btn-primary rounded-full py-6">{loading ? "Signing in…" : "Sign in"}</Button>
        <div className="relative py-2"><div className="metal-line absolute inset-x-0 top-1/2"/><div className="relative bg-white text-xs text-center text-[color:var(--text-muted)] w-fit mx-auto px-3">or</div></div>
        <Button data-testid="login-google" type="button" onClick={google} variant="outline" className="w-full rounded-full py-6">Continue with Google</Button>
      </form>
      <p className="mt-6 text-center text-sm text-[color:var(--text-muted)]">No account? <Link to="/register" className="underline">Create one</Link></p>
    </div>
  );
}
